/**
 * scrollCardIntoView utility
 *
 * Scrolls a target card into view within a scroll container using smooth
 * scrolling. Skips scrolling if the card is already fully visible.
 *
 * Shared between keyboard navigation (useCardGridNavigation) and
 * auto-advance after label application (useModerationWorkQueueSetup).
 */

/**
 * Smoothly scrolls a card into view within the given scroll container,
 * but only if it is partially or fully outside the visible area.
 *
 * @param scrollContainer - The scrollable parent element
 * @param targetCard - The card element to scroll into view
 */
export function scrollCardIntoView(scrollContainer: HTMLElement, targetCard: HTMLElement): void {
  const containerRect = scrollContainer.getBoundingClientRect();
  const cardRect = targetCard.getBoundingClientRect();

  if (cardRect.top < containerRect.top || cardRect.bottom > containerRect.bottom) {
    const offsetTop = cardRect.top - containerRect.top + scrollContainer.scrollTop;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scrollContainer.scrollTo({ top: offsetTop, behavior: prefersReducedMotion ? 'instant' : 'smooth' });
  }
}
